
import { FormControl, InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import DefaultSelect from '../default-select/DefaultSelect';
import React, { RefCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ILoginCustomer } from "../../common/models/LoginCustomer";

export type CustomerListProps = {
    value: number;
    customers: ILoginCustomer[],
    onSelected?: (selectedCustomer: number) => void;
    selectRef: React.RefObject<HTMLElement | null> | RefCallback<HTMLElement>;
};

export default function CustomerList({value, customers, selectRef, onSelected}: CustomerListProps) {
    
    const { t } = useTranslation();

    const handleChange = (event: SelectChangeEvent<number>/*, child: React.ReactNode*/) => {

        const value = event.target.value as number;

        if (onSelected) {
            onSelected(value);
        }
    };

    return (
        <FormControl fullWidth sx={{
            minWidth: 120
          }}>
            <InputLabel id="customer-list-label">{t("customer.selectCustomer")}</InputLabel>
            <DefaultSelect
                labelId="customer-list-label"
                id="customer-list-select"
                value={value ? value : 0}
                onChange={handleChange}
                required
                inputRef={selectRef}
                label={t("customer.selectCustomer")}
                variant="standard">
                    <MenuItem key={-1} value={0} disabled >
                    {t("customer.selectCustomer")}
                    </MenuItem>
                {
                    customers.map((item, index) => (
                        <MenuItem key={index} value={item.customerID} >
                            {item.customerName}
                        </MenuItem>
                    ))
                }

            </DefaultSelect>
      </FormControl>
    );
  }
